import { useState, useEffect, useContext } from "react";
// react-router components
import { useNavigate, useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import {
  AppBar,
  Toolbar,
  Snackbar,
  Alert,
  Menu,
  Icon,
  Badge,
  Box,
  Divider,
  Avatar,
  Drawer,
  Tab,
  FormControl,
  TextField,
  Grid,
  Button,
  Typography,
} from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import IconButton from "@mui/material/IconButton";
import LogoutIcon from "@mui/icons-material/Logout";
import PersonIcon from "@mui/icons-material/Person";
import SettingsIcon from "@mui/icons-material/Settings";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Material Dashboard 2 React example components
import Breadcrumbs from "components/Breadcrumbs";
import NotificationItem from "components/Items/NotificationItem";

import LogoutDialog from "../../Header/LogoutDialog";
import AuthContext from "../../../store/auth-context";
import useLogout from "hooks/useLogout";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import {
  API_ROUTES,
  ID_GROUP_CAPTINH,
  ID_GROUP_CHUTHE,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  ModeAuthorizeEnum,
  PermissionMenuKey,
  useStyles,
} from "../../../utils/constants";
// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "components/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "context";
import PersonalProfile from "./components/PersonalProfile";
import SaveIcon from "@mui/icons-material/Save";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { AlertState } from "states";
import { CountNotificationState } from "states";
import LoadingCircle from "components/LoadingCircle/loadingCircle";
import LockClockIcon from "@mui/icons-material/LockClock";
import { IdExpiredProductSelectState } from "states";
import { Message } from "@mui/icons-material";
import Authorize from "components/Authorize";
function DashboardNavbar({ absolute = false, light = false, isMini = false }) {
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const {
    miniSidenav,
    transparentNavbar,
    fixedNavbar,
    openConfigurator,
    darkMode,
  } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const route = useLocation().pathname.split("/").slice(1);
  const [validationErrors, setValidationErrors] = useState({});
  const setAlert = useSetRecoilState(AlertState);
  const axiosPrivateInstance = useAxiosPrivate();

  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(
        dispatch,
        (fixedNavbar && window.scrollY === 0) || !fixedNavbar
      );
    }

    /** 
     The event listener that's calling the handleTransparentNavbar function when 
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => window.removeEventListener("scroll", handleTransparentNavbar);
  }, [dispatch, fixedNavbar]);
  useEffect(() => {}, [onLogout]);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);
  const handleOpenProfile = (event) => setOpenProfile(event.currentTarget);
  const handleCloseProfile = () => setOpenProfile(false);
  const [open, setOpen] = useState(false);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const handleOpenDialogProfile = (event) => setOpenDialog(event.currentTarget);
  const handleCloseDialogProfile = () => setOpenDialog(false);

  const [show, setShow] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [dataRow, setDataRow] = useState({});
  const [isError, setIsError] = useState(false);
  const classes = useStyles();
  const [tab, setTab] = useState("1");

  //thông báo
  const setIDSelectState = useSetRecoilState(IdExpiredProductSelectState);
  const [isLoadingNoti, setIsLoadingNoti] = useState(false);
  const [notifications, setNotifications] = useState([]);

  const countNotiState = useRecoilValue(CountNotificationState);
  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
  };
  const handleLogoutClick = () => {
    setLogoutDialogOpen(true);
  };

  const handleLogoutConfirm = () => {
    onLogout();
    setOpen(true);
    setLogoutDialogOpen(false);
  };

  const handleLogoutCancel = () => {
    setLogoutDialogOpen(false);
    setOpenProfile(false);
  };

  const logout = useLogout();
  const { accessToken, statusAuth, user, setStatusAuth } =
    useContext(AuthContext);
  const navigate = useNavigate();

  async function onLogout() {
    setLoading(true);
    await logout();
    setStatusAuth("logout");
    navigate("/", { state: { successMessage: "Đăng xuất thành công!" } });
  }
  const handleShowProfile = async () => {
    try {
      const response = await axiosPrivateInstance.get("user");
      setDataRow({ ...response.data });
    } catch (error) {
      setIsError(true);
      return;
    }
    setTitle("Thông tin tài khoản người dùng");
    setModalOpen(true);
    setOpenProfile(false);
    setValidationErrors({});
  };

  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  const handleOpenMenu = (event) => {
    setOpenMenu(event.currentTarget);
    const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
    const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
    const isGroupPhuong = checkGroupUser(user, ID_GROUP_PHUONGXA);
    const isGroupOne = checkGroupUser(user, ID_GROUP_NUMBER_ONE);
    const isGroupTinh = checkGroupUser(user, ID_GROUP_CAPTINH);
    if (isOwner || isGroupSeven || isGroupPhuong || isGroupOne || isGroupTinh) {
      setIsLoadingNoti(true);
      let body = {
        maquan: isGroupSeven ? user.maquan : undefined,
        username: isOwner ? user?.username : undefined,
        maphuong: isGroupPhuong ? user?.maphuong : undefined,
      };

      axiosPrivateInstance
        .get(API_ROUTES.THONGBAO, { params: body })
        .then((response) => {
          setNotifications(response.data?.data);
        })
        .catch((error) => {
          console.log(error);
          return;
        })
        .finally(() => {
          setIsLoadingNoti(false);
        });
    }
  };
  const handleCloseMenu = () => setOpenMenu(false);
  const handleToClickProductExpried = (idSanPham, idChuThe) => (e) => {
    setOpenMenu(false);
    navigate(`/quanlysanphamocop/${PermissionMenuKey.phieudangky}`);
    setIDSelectState({
      idSanPham: idSanPham,
      idChuThe: idChuThe,
    });
  };
  // Render the notifications menu
  const renderMenu = () => {
    return (
      <Menu
        anchorEl={openMenu}
        anchorReference={null}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        open={Boolean(openMenu)}
        onClose={handleCloseMenu}
        sx={{ mt: 2 }}
      >
        {isLoadingNoti ? (
          <div className="flex items-center justify-center">
            <LoadingCircle />
          </div>
        ) : notifications?.length > 0 ? (
          notifications?.map((item) => (
            <NotificationItem
              key={"sanphamhethandangky_" + item?.id}
              icon={<LockClockIcon />}
              title={item?.sanpham_ten}
              onClick={handleToClickProductExpried(
                item?.sanpham_id,
                item?.chuthe_id
              )}
            />
          ))
        ) : (
          <NotificationItem icon={<Message />} title="Không có thông báo" />
        )}
      </Menu>
    );
  };
  const renderProfile = () => (
    <Menu
      anchorEl={openProfile}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openProfile)}
      onClose={handleCloseProfile}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        icon={<PersonIcon />}
        title="Thông tin tài khoản"
        onClick={handleShowProfile}
      />
      <Authorize
        mode={ModeAuthorizeEnum.view}
        permission={PermissionMenuKey.setting}
      >
        <NotificationItem
          icon={<SettingsIcon />}
          title="Thiết lập hệ thống"
          onClick={toggleSlider}
        />
      </Authorize>
      <NotificationItem
        icon={<LogoutIcon />}
        title="Đăng xuất"
        onClick={handleLogoutClick}
      />
    </Menu>
  );
  const toggleSlider = () => {
    // setShow(!show);
    // setOpenProfile(false);
    navigate("/setting");
  };
  const sideList = () => (
    <Box component="div">
      <Avatar
        sx={{ width: 64, height: 64, textAlign: "center" }}
        src="/media/tamky.jpeg"
        alt="Juaneme8"
      />
      <IconButton
        title="Thu nhỏ"
        aria-label="close"
        onClick={toggleSlider}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <MenuOpenIcon />
      </IconButton>
      <Divider />
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={1} direction="row" sx={{ padding: "0 10px" }}>
          <Grid item xs={12}>
            <MDTypography
              color="info"
              backgroundColor="#9e9e9e3b"
              component="h6"
            >
              <span>Cấu hình Email:</span>
            </MDTypography>
          </Grid>
          <Grid item xs={12}>
            <TextField size="small" fullWidth name="email" label="Email:" />
          </Grid>
          <Grid item xs={12}>
            <TextField
              size="small"
              type="password"
              fullWidth
              name="password"
              label="Password:"
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              color="primary"
              variant="contained"
              startIcon={<SaveIcon />}
              size="small"
              // onClick={onSubmitForm}
              sx={{ color: "#ffffff", float: "right" }}
            >
              Lưu
            </Button>
          </Grid>
        </Grid>
        {/* <TabContext value={tab}>
          <TabList
            onChange={handleChangeTab}
            centered
            textColor="primary"
            indicatorColor="secondary"
          >
            <Tab label="Cấu hình Email" value="1" />
            <Tab label="Thông tin hệ thống" value="2" />
          </TabList>
          <TabPanel value="1" sx={{ p: 0 }}>
            <>
              <FormControl
                sx={{ m: 1, width: 500, borderRadius: "5px", backgroundColor: "floralwhite" }}
                size="small"
              ></FormControl>
            </>
          </TabPanel>
          <TabPanel value="2" sx={{ p: 0 }}>
            <>
              <FormControl
                sx={{
                  mt: 1,
                  ml: 1,
                  width: 260,
                  borderRadius: "5px",
                  backgroundColor: "floralwhite",
                }}
                size="small"
              ></FormControl>
              <FormControl
                sx={{ mt: 1, width: 120, borderRadius: "5px", backgroundColor: "floralwhite" }}
                size="small"
              ></FormControl>
              <FormControl
                sx={{
                  mt: 1,
                  mr: 1,
                  width: 120,
                  borderRadius: "5px",
                  backgroundColor: "floralwhite",
                }}
                size="small"
              >
                <TextField
                  size="small"
                  fullWidth
                  id="thuadatso"
                  name="thuadatso"
                  label="Thửa đất số:"
                  type="number"
                />
              </FormControl>
            </>
          </TabPanel>
        </TabContext> */}
      </Box>
    </Box>
  );
  // Styles for the navbar icons
  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });
  const handleSave = async (values) => {
    try {
      const response = await axiosPrivateInstance.put(
        "updateinforuser/" + values.id,
        { ...values }
      );

      setAlert({
        alert: true,
        message: `Cập nhật thành công!${
          values.auth2 ? "-Vui lòng đăng nhập lại và xác nhận OTP" : ""
        }`,
        type: "success",
      });
      if (values.auth2) {
        // onLogout();
      }
      setValidationErrors({});
      // setModalOpen(false);
    } catch (error) {
      let validErrors = {};
      if (error && error.response) {
        Object.entries(error.response.data).forEach(([key, value]) => {
          let val = value;
          if (Array.isArray(value)) {
            value.map((item) => {
              val += item;
            });
          } else {
            val = value;
          }
          validErrors = { ...validErrors, [key]: val };
        });
      } else {
        validErrors = { ...validErrors, error: error };
      }
      setValidationErrors(validErrors);
      return;
    }
  };
  return (
    <>
      <AppBar
        position={absolute ? "absolute" : navbarType}
        color="inherit"
        sx={(theme) =>
          navbar(theme, { transparentNavbar, absolute, light, darkMode })
        }
      >
        <Toolbar sx={(theme) => navbarContainer(theme)}>
          <MDBox
            color="inherit"
            mb={{ xs: 1, md: 0 }}
            sx={(theme) => navbarRow(theme, { isMini })}
          >
            <Breadcrumbs
              icon="home"
              title={
                route?.length > 3
                  ? route[route.length - 2]
                  : route[route.length - 1]
              }
              route={
                route?.length > 3 ? route.slice(0, route?.length - 1) : route
              }
              light={light}
            />
          </MDBox>
          {isMini ? null : (
            <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
              <MDBox color={light ? "white" : "inherit"}>
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={handleOpenMenu}
                >
                  <Badge color="primary" badgeContent={countNotiState}>
                    <Icon sx={iconsStyle}>notifications</Icon>
                  </Badge>
                </IconButton>
                {renderMenu()}
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  onClick={handleConfiguratorOpen}
                >
                  <Icon sx={iconsStyle}>settings</Icon>
                </IconButton>
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarMobileMenu}
                  onClick={handleMiniSidenav}
                >
                  <Icon sx={iconsStyle} fontSize="medium">
                    {miniSidenav ? "menu_open" : "menu"}
                  </Icon>
                </IconButton>
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={handleOpenProfile}
                >
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
                {renderProfile()}
                <LogoutDialog
                  open={logoutDialogOpen}
                  onClose={handleLogoutCancel}
                  onLogout={handleLogoutConfirm}
                />
              </MDBox>
            </MDBox>
          )}
          <PersonalProfile
            data={dataRow}
            open={modalOpen}
            title={title}
            onClose={() => {
              setModalOpen(false);
              setValidationErrors({});
            }}
            validationErrors={validationErrors}
            onSubmit={handleSave}
          />
          <Drawer
            open={show}
            classes={{
              paper: classes.customPaper,
            }}
            anchor="right"
            onClose={toggleSlider}
          >
            {sideList()}
          </Drawer>
        </Toolbar>
      </AppBar>
    </>
  );
}

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
